import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import './SubscriptionSuccess.css';

const SubscriptionSuccess: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [countdown, setCountdown] = useState(5);
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    // Countdown and redirect
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          window.location.href = '/dashboard';
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="subscription-success-page">
      <div className="success-container">
        <div className="success-icon">✅</div>
        <h1>Payment Successful!</h1>
        <p className="success-message">
          Thank you for subscribing to MemoirCraft. Your subscription has been activated successfully.
          Thank you for subscribing to Debriefr. Your subscription has been activated successfully.
        </p>

        <div className="success-details">
          <div className="detail-box">
            <span className="detail-icon">🎉</span>
            <div className="detail-text">
              <h1>Welcome to Debriefr Premium!</h1>
              <p>Thank you for subscribing. You now have access to all premium features.</p>
            </div>
          </div>

          {sessionId && (
            <div className="detail-box">
              <span className="detail-icon">📧</span>
              <div className="detail-text">
                <h3>Confirmation Email</h3>
                <p>A receipt has been sent to your email address</p>
              </div>
            </div>
          )}

          <div className="detail-box">
            <span className="detail-icon">⚙️</span>
            <div className="detail-text">
              <h3>Manage Subscription</h3>
              <p>You can manage your subscription anytime from your account settings</p>
            </div>
          </div>
        </div>

        <div className="redirect-notice">
          <p>Redirecting to dashboard in <strong>{countdown}</strong> seconds...</p>
        </div>

        <div className="success-actions">
          <Link to="/dashboard" className="btn btn-primary">
            Go to Dashboard Now
          </Link>
          <Link to="/subscription" className="btn btn-secondary">
            View Subscription Details
          </Link>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionSuccess;
